export default __webpack_public_path__ + "static/3-8cd52f98d577bdcacde7a75d2f17e61a.webp";